import { Button, Container } from "@mui/material";
import styles from "./HomeUnit.module.scss";
import { IconPack } from "Explore/Config/Icons";
import { useEffect, useRef, useState } from "react";
import { getAllUnitExplore } from "Explore/Services/Unit";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import HomeUnitCard from "./HomeUnitCard";
import { Skeleton } from "antd";

const HomeUnit = () => {
  const [data, setData] = useState({
    data: Array.from({ length: 8 }),
    isLoading: true,
  });
  const swiperRef = useRef(null);

  useEffect(() => {
    getAllUnitExplore(0, 8, (res) => {
      setData({
        data: res.results,
        isLoading: false,
      });
    });
  }, []);

  return (
    <div className={styles["home-unit"]}>
      <Container maxWidth="lg" className={styles["home-unit--title"]}>
        <p>
          More than 10,000&nbsp;
          <a href={`/explore/units`}>research units</a>
        </p>
      </Container>

      <Swiper
        modules={[Autoplay]}
        slidesPerView="auto"
        centeredSlides={true}
        spaceBetween={80}
        loop
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        ref={swiperRef}
        speed={500}
        className={styles["home-unit--swiper"]}
        allowTouchMove={false}
      >
        {data.data.map((e, i) => (
          <SwiperSlide
            className={styles["home-unit--swiper--slide"]}
            key={i}
            style={{
              minHeight:
                swiperRef.current?.getBoundingClientRect().height ?? "auto",
            }}
          >
            {data.isLoading ? (
              <Skeleton.Input active />
            ) : (
              <HomeUnitCard data={e} />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default HomeUnit;
